import { useField } from "formik";

interface CheckboxProps {
  name: string;
  children: React.ReactNode;
}

const Checkbox = ({ name, children }: CheckboxProps) => {
  const [field, meta] = useField(name);

  return (
    <label
      htmlFor={name}
      className={`relative checkbox-label ${
        meta.touched && meta.error ? "has-error" : ""
      }`}
    >
      
      {meta.touched && meta.error && (
        <div className="mb-2">
          <div className="validation-error block ">{meta.error}</div>
        </div>
      )}
      
      <div className="flex relative">
        <input
          id={name}
          {...field}
          type="checkbox"
          className="w-auto m-0 mr-6 top-1.5 min-h-6 min-w-6 cursor-pointer"
        />
        <div>{children}</div>
      </div>
    </label>
  );
};

export default Checkbox;
